@if (user) {
  <div class="signature forceDefaultColors" [class.initials]="type === PositionElementEnum.Initials">
    @if (
      format === SignatureFormat.Handwriting ||
      (type === PositionElementEnum.Initials && (format === SignatureFormat.Eletronic || (format === SignatureFormat.Image && !imageUrl) || (format === SignatureFormat.Draw && !drawingUrl)))
    ) {
      <div class="signature__handwriting {{ (font || '').toLowerCase() }}">{{ displayName }}</div>
    } @else if (type !== PositionElementEnum.Initials && format === SignatureFormat.Eletronic) {
      <div class="signature__eletronic">{{ 'signature.electronicallySigned' | translate }}</div>
    } @else if (format === SignatureFormat.Image && imageUrl) {
      <div class="signature__img" [ngStyle]="{ backgroundImage: 'url(' + imageUrl + ')' }"></div>
    } @else if (format === SignatureFormat.Draw && drawingUrl) {
      <div class="signature__img" [ngStyle]="{ backgroundImage: 'url(' + drawingUrl + ')' }"></div>
    }

    <div class="signature__title">
      @if (type === PositionElementEnum.Signature) {
        <div class="fal fa-signature"></div>
        {{ 'signature.signature' | translate }}
      } @else if (type === PositionElementEnum.Initials) {
        <div class="fal fa-spell-check"></div>
        {{ 'signature.initials' | translate }}
      }
    </div>
  </div>
}
